/* eslint-disable no-restricted-imports */
import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctValue } from '../../../../Fct/generics';
import { getSupportedTokens } from '../../../../Fct/plugins/allowanceRequiredProtocols';
export var Allowance = createPlugin({
    protocol: 'ERC20',
    type: 'GETTER',
    method: 'allowance',
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({
                    destination: 'erc20',
                    options: getSupportedTokens({ chainId: chainId }),
                }),
                methodParams: {
                    owner: new FctAddress({}),
                    spender: new FctAddress({}),
                },
            },
            output: {
                allowance: new FctValue({ destination: 'wei_amount', innerIndex: 0 }),
            },
        });
    },
});
